
export default class tdDeploy {

    /**
     *  Here we get the API URL from webpack. Have a look at:
     *  - webpack.dev.conf.js  - for dev
     *  - webpack.prod.conf.js - for production
     */
    static tdIflowVersion = TAGDIV_IFLOW_VERSION;
    static apiUrl = TAGDIV_API_URL;
    static apiThumbUrl = TAGDIV_API_THUMB_URL;
    static apiUploadUrl = TAGDIV_API_UPLOAD_URL;
    static apiUploadPhotoUrl = TAGDIV_API_UPLOAD_PHOTO_URL;
    static apiStaticUrl = TAGDIV_STATIC_URL;


    // the cookie id generated from topSiteMessage_ + TAGDIV_IFLOW_VERSION in webpack.prod.conf.js etc...
    static topSiteMessageCookie = TAGDIV_TOP_SITE_MESSAGE_COOKIE;

    // used for cache busting for the worker script on the schedule
    static cacheBusterRandomQuery = TAGDIV_CACHE_BUSTER;


}



// WEBPACK FOOTER //
// ./src/tdDeploy.js